export enum AccessType {
  globalAdmin = "GlobalAdmin",
  groupAdmin = "GroupAdmin",
  viewer = "Viewer",
  billing = "Billing",
}

export enum UserStatus {
  active = "active",
  inactive = "inactive",
  expiring = "expiring",
  expired = "expired",
}

export interface GroupAccessTypeMapping {
  groupId: string;
  accessType: AccessType;
}

export interface User {
  _id: string;
  username: string;
  email: string;
  groupAccessTypeMapping: GroupAccessTypeMapping[];
  password?: string; // This should be stored only for dummy users
  expirationDate: Date | null;
  isDummy?: boolean;
  isActive?: boolean;
}

export interface UserOption {
  id: string;
  username: string;
  email?: string;
}

export interface ComponentRoleAssignmentUserOption extends UserOption {
  isGroupMember: boolean;
  canAssign: boolean;
}

export type UserMenuType = "basic" | "extended";

export enum SortByMenuOptions {
  Alphabetically = "Alphabetically",
  RecentlyAdded = "Recently Added",
}

export interface SortAndFilterOptions {
  filterByStatus: (UserStatus | string)[];
  filterByGroups: string[];
  filterByAccessType: (AccessType | string)[];
  filterByAccessPermissions: string;
  sortBy: string;
}

export const defaultSortAndFilterOptions: SortAndFilterOptions = {
  filterByStatus: ["All"],
  filterByGroups: ["All"],
  filterByAccessType: ["All"],
  filterByAccessPermissions: "",
  sortBy: SortByMenuOptions.Alphabetically,
};

// Dummy user banner requires a user. groupName is optional and would be applicable only in the create-group workflow.
export interface DummyUserBannerItem {
  user: User;
  groupName?: string;
}
